import { useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Collapse, IconButton, TableCell } from "@mui/material";
import { MathJaxOutput } from "../mathJax/MathJaxOutput";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function FormTiny(props: any) {
  const editorRef = useRef<any>();
  const [open, setOpen] = useState(false);

  const onChange = (e: string) => {
    props.onChange(editorRef.current.id, e);
  };
  return (
    <div className="EditForm">
      <label className="EditTinyLabel">{props.title}</label>

      <div className="EditInputHolder">
        <Editor
          init={{
            relative_urls: false,
            // remove_script_host: false,
            // document_base_url: "https://minimath239.ru",
            promotion: false,
            height: 500,
            menubar: true,
            plugins: [
              "advlist",
              "autolink",
              "link",
              "image",
              "lists",
              "preview",
              "code",
            ],
            toolbar:
              "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | preview",
            // content_style:
            //   "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
          tinymceScriptSrc="/tinymce/tinymce.min.js"
          id={props.id}
          value={props.value}
          onEditorChange={onChange}
          onInit={(evt: any, editor: any) => (editorRef.current = editor)}
        />
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={() => setOpen(!open)}
        >
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
        предпросмотр
        <Collapse in={open} timeout="auto" unmountOnExit>
          <div className="EditTinyPreview">
            <MathJaxOutput text={props.value} />
          </div>
        </Collapse>
      </div>
    </div>
  );
}

export default FormTiny;
